export const hasAvailableKyc = () => {
  return true;
};
